'use client';

import { Transition } from '@headlessui/react';
import * as Popover from '@radix-ui/react-popover';
import { useState } from 'react';

import { useTranslate } from '@/contexts/labels';
import { Button } from '@/ui/Button';
import { cx } from '@/ui/cva';
import { Icon } from '@/ui/Icon';

type ShareCopyButtonProps = {
    url: string;
};

export function ShareCopyButton({ url }: ShareCopyButtonProps) {
    const [open, setOpen] = useState(false);

    const t = useTranslate('shareDialog');

    function handleClick() {
        navigator.clipboard.writeText(url);
    }

    return (
        <Popover.Root open={open} onOpenChange={setOpen} modal={false}>
            <Popover.Trigger asChild>
                <Button
                    className="h-md w-md flex-none p-0"
                    variant="outlined"
                    color="gray"
                    aria-label={t('copy')}
                    onClick={handleClick}
                >
                    <Icon className="text-xl">copy_all</Icon>
                </Button>
            </Popover.Trigger>
            <Popover.Portal forceMount>
                <Transition show={open}>
                    <Popover.Content
                        forceMount
                        collisionPadding={10}
                        side="top"
                        sideOffset={5}
                        className={cx(
                            'z-50 rounded-xl bg-green p-xs text-sm text-white shadow-xl outline-none transition',
                            'transition',
                            'data-[closed]:opacity-0',
                            'data-[closed]:data-[side=top]:translate-y-1',
                            'data-[closed]:data-[side=bottom]:-translate-y-1'
                        )}
                    >
                        <div>{t('copied')}</div>
                        <Popover.Arrow
                            className="fill-green"
                            width={12}
                            height={6}
                        />
                    </Popover.Content>
                </Transition>
            </Popover.Portal>
        </Popover.Root>
    );
}
